import React from "react";

import { Tooltip as AntTooltip, TooltipProps as AntTooltipProps } from "antd";

type TooltipProps = AntTooltipProps & {
  disabled?: boolean;
  mRef?: React.RefObject<HTMLSpanElement>;
};

export const Tooltip = ({ mRef, style, ...props }: TooltipProps) => {
  const tooltipStyle = { color: "#fff" };

  // Easy way to remove tooltips in certain contexts
  if (props.disabled) {
    return (
      <span ref={mRef} style={{ display: "inline-block", ...style }}>
        {props.children}
      </span>
    );
  }

  return (
    <AntTooltip color={"#065c45"} zIndex={10002} styles={{ body: tooltipStyle }} destroyOnHidden={true} mouseLeaveDelay={0.1} mouseEnterDelay={0.3} {...props}>
      <span ref={mRef} style={{ display: "inline-block", ...style }}>
        {props.children}
      </span>
    </AntTooltip>
  );
};

export default Tooltip;
